import { useMappingFormStore } from '../stores/mappingFormStore';

export const useMappingForm = () => {
  const formInstance = useMappingFormStore((state) => state.formInstance);
  const setFormInstance = useMappingFormStore((state) => state.setFormInstance);
  const clearFormInstance = useMappingFormStore(
    (state) => state.clearFormInstance
  );
  const getFormInstance = useMappingFormStore((state) => state.getFormInstance);
  const validateForm = useMappingFormStore((state) => state.validateForm);
  const resetFormErrors = useMappingFormStore((state) => state.resetFormErrors);

  return {
    form: formInstance,
    setFormInstance,
    clearFormInstance,
    getFormInstance,
    validateForm,
    resetFormErrors,
  };
};
